/**
 * Money is never shown to a customer with more than two decimals.
 *
 * `toLocaleString('en')` with no options allows up to THREE fraction digits,
 * which is how the proposal came to print `$10,252.306` and `$1,697.694` for
 * the CCTV and Security System section prices (Jaron's screenshot,
 * 2026-08-26). The TOTAL underneath was right because it goes through a
 * different path, so the same page showed money two different ways.
 *
 * Only the maximum is capped, not the minimum: a whole price stays `$300`
 * rather than becoming `$300.00`, which keeps this to the defect and out of
 * every other price on the report. The capped values still add up — 10252.31
 * + 1697.69 is the 11950.00 the TOTAL prints.
 */
const MONEY = { maximumFractionDigits: 2 } as const

export const FormatPrice = (price: number, symbol: string) => {
  if (isNaN(price)) return '0'
  if (price < 0) {
    // Was `parseFloating(price.toString().replace('-', ''))`, which is a long
    // way round to Math.abs and dragged the whole `common` barrel — and its
    // env-var boot — into a pure formatting helper, so it could not be tested.
    return `-${symbol}${Math.abs(price).toLocaleString('en', MONEY)}`
  }

  return `${symbol}${price.toLocaleString('en', MONEY)}`
}
